<script>
import { Base as BaseApi } from 'firepuma-vue-axios-vuex-extensions/axios-utils/apiBase';

export default {
  props: {
    method: { type: String },
    url: { type: String },
    payload: { type: Object },

    showBusy: { type: Boolean, default: () => true },
    showError: { type: Boolean, default: () => true },
  },

  data: () => ({
    result: undefined,
    busy: false,
    error: undefined,

    errorVisible: false,
  }),

  methods: {
    async trigger({ method, url, payload, doNotHandleError } = {}) {
      // Ensure we did not specify both the prop and argument (should be either)

      if (method && this.method) {
        alert(`Developer problem: please choose between passing a method as an argument to the trigger func or setting method prop`);
        return;
      } else if (!method && !this.method) {
        throw new Error('Developer problem: either specify the method prop or method argument')
      }

      if (url && this.url) {
        alert(`Developer problem: please choose between passing a url as an argument to the trigger func or setting url prop`);
        return;
      } else if (!url && !this.url) {
        throw new Error('Developer problem: either specify the url prop or url argument')
      }

      if (payload && this.payload) {
        alert(`Developer problem: please choose between passing a payload as an argument to the trigger func or setting payload prop`);
        return;
      }

      this.error = undefined;
      this.busy = true;
      try {
        let base = new BaseApi();
        let api = base.api();

        let result = await api.request({ method: method || this.method, url: url || this.url, data: payload || this.payload });
        result = await base.handleResponse(result);

        this.$emit('executed', result);
        this.result = result;
        return result;
      } catch (err) {
        if (doNotHandleError) {
          throw err;
        } else {
          this.error = String(err);
        }
      } finally {
        this.busy = false;
      }
    },
  },
}
</script>

<template>
  <div>
    <b-card v-if="busy && showBusy" class="my-3"> <i class="fa fa-spinner fa-spin"></i> </b-card>

    <b-alert v-if="error && showError && errorVisible" variant="danger" show dismissible class="mr-2">{{error}}</b-alert>
    <button v-if="error && showError" type="button" class="btn btn-sm mr-2" :class="[errorVisible ? 'btn-danger' : 'btn-outline-danger']" @click="errorVisible=!errorVisible">
      <i class="fa fa-exclamation-triangle"></i>
    </button>

    <slot :trigger="trigger" :busy="busy" :error="error" :result="result"></slot>
  </div>
</template>



// WEBPACK FOOTER //
// src/AxiosApiTrigger.vue